export default __webpack_public_path__ + "6be9371af28fa21cb87eb83e21297e5a.png";